import React, { useEffect, useState } from "react";
import { BsInfoCircle, BsEye, BsEyeSlash } from "react-icons/bs";
import server from "../api/server.js";
import "./login.css";
import { useToast } from "../context/ToastContext.jsx";

const ManualLogin = ({ login }) => { // Destructure `login` properly
    const { showToast } = useToast();
    const [showLogin, setShowLogin] = useState(false);
    const [showOTPInput, setShowOTPInput] = useState(false);
    const [showRestPasswordPage, setShowResetPasswordPage] = useState(false);
    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [otp, setOTP] = useState("");
    let [showResetPage, setShowResetPage] = useState(false);
    let [newPassword, setNewPassword] = useState("");
    let [newConfirmPassword, setNewConfirmPassword] = useState("");
    let [resendAllowed, setResendAllowed] = useState(false);
    let [countdown, setCountdown] = useState(60);
    let [apiCallRunning, setApiCallRunning] = useState(false);
    const isMobile = window.innerWidth <= 768;
    let [showMoreInfo, setShowMoreInfo] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword); // Toggle the state
    };
    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    }
    const toggleNewConfirmPasswordVisibility = () => {
        setShowConfirmNewPassword(!showConfirmNewPassword);
    }

    const handleCloseLogin = () => {
        login(false);
    }
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };
    const handleVerificationSend = async () => {
        if(apiCallRunning){
            return;
        }
        if(!email){
            showToast("Please enter your email", "error");
        }else if(!isValidEmail(email)){
            showToast("Please enter a valid email", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.sendVerificationOTP(email);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("Verification code sent to your email", "success");
                    setShowOTPInput(true);
                    setCountdown(60);
                    setResendAllowed(false);
                }else if(response.status===404){
                    showToast("User not found", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleLogin = async() => {
        if(apiCallRunning){
            return;
        }
        if(!email || !password){
            showToast("Please enter your email and password", "error");
        }else if(!isValidEmail(email)){
            showToast("Please enter a valid email", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.login(email, password);
                setApiCallRunning(false);
                let resp = await response.json();
                if(response.status === 200){
                    login(false, {info: resp.info, services: resp.services, session_id: resp.session_id, access_token_expires_at: resp.access_token_expires_at});
                }else if(response.status === 401){
                    showToast(resp.error, "error");
                }else if(response.status === 404){
                    showToast(resp.error, "error");
                }else{
                    showToast(resp.error, "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleOTPVerification = async () => {
        if(apiCallRunning){
            return;
        }
        if(!otp){
            showToast("Please enter your OTP", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.otpValidation(email, otp);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("OTP verified successfully", "success");
                    setShowResetPasswordPage(false);
                    setShowResetPage(true);
                }else if(response.status === 400){
                    showToast("Invalid or expired OTP", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleOTPResend = async () => {
        if(apiCallRunning){
            return;
        }
        if(!email){
            showToast("Please enter your email", "error");
        }else if(!isValidEmail(email)){
            showToast("Please enter a valid email", "error");
        }else{
            try {
                setApiCallRunning(true);
                let response = await server.sendVerificationOTP(email);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("OTP resent successfully", "success");
                    setShowOTPInput(true);
                    setCountdown(60);
                    setResendAllowed(false);
                }else if(response.status===404){
                    showToast("User not found", "error");
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }
    const handleResetPassword = async () => {
        if(apiCallRunning){
            return;
        }
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).+$/; // At least one letter and one number
    
        if (!newPassword || !newConfirmPassword) {
            showToast("Please enter your new password and confirm new password", "error");
        } else if (newPassword !== newConfirmPassword) {
            showToast("New password and confirm new password do not match", "error");
        } else if (newPassword.length < 8) {
            showToast("New password must be at least 8 characters", "error");
        } else if (!passwordRegex.test(newPassword)) {
            showToast("New password must contain at least one letter and one number", "error");
        } else {
            try {
                setApiCallRunning(true);
                let response = await server.resetPassword(email, newPassword);
                setApiCallRunning(false);
                if(response.status === 200){
                    showToast("Password reset successfully", "success");
                    setShowResetPage(false);
                    setShowResetPasswordPage(false);
                }else{
                    showToast("Try again later.", "error");
                }
            } catch (error) {
                showToast("Try again later.", "error");
            }
        }
    }    

    useEffect(() => {
        setShowLogin(true); // Set to true to show login on open
    }, []);
    useEffect(() => {
        let timer;
        if (countdown > 0 && !resendAllowed) {
            timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        setResendAllowed(true); // Allow resend after countdown reaches zero
                        clearInterval(timer);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(timer); // Cleanup on unmount or countdown change
    }, [countdown, resendAllowed]);

    return (
        <div className="fixed top-0 right-0 h-full bg-white transition-transform" style={{ transform: showLogin ? 'translateX(0)' : 'translateX(100%)', width: (!isMobile) ? "50%":"100%", transitionDuration: "1s" }}>
            <div style={{ padding: '2rem', position: 'relative' }}>
                <button onClick={handleCloseLogin} style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '24px' }}>✖</button>
                {
                    showMoreInfo && (
                        <div className="more-info-box">
                            If you're a first-time user or have forgotten your password, please use the "Reset Password" option.
                        </div>
                    )
                }
                <h2 style={{ textAlign: 'center', fontSize: '51px', fontWeight: '600', marginBottom: '1rem', display: "flex", alignItems: "center", justifyContent: "center", marginTop: (!isMobile) ? "11.5rem":"7rem" }}>{(showRestPasswordPage || showResetPage) ? "Reset Password" : "Log In" }
                     </h2>
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
                    {
                        !showRestPasswordPage && !showResetPage && (
                            <>
                            <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", color: "#343434", marginBottom: "0.3rem"}}>Email</span>
                            <input
                                value={email}
                                type="email"
                                id="email"
                                onChange={(e)=> {setEmail(e.target.value)}}
                                placeholder="name@company.com"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                            {/* <input class="global-input"type="email" placeholder="name@company.com" onChange={(e)=>setEmail(e.target.value)} style={{padding: '0.5rem', marginBottom: '1rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "50%":"80%" }} /> */}
                            <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", color: "#343434", marginBottom: "0.3rem", marginTop: "0.5rem"}}>Password</span>
                    <div style={{display: 'flex', alignItems: 'center', marginLeft: (!isMobile) ? '3%':'20%'}}>
                    <input
                                value={password}
                                type={showPassword ? "text" : "password"}
                                id="password"
                                onChange={(e)=> {setPassword(e.target.value)}}
                                placeholder="password"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                    {/* <input class="global-input"type={showPassword ? "text" : "password"} placeholder="password" onChange={(e) => setPassword(e.target.value)} style={{ padding: '0.5rem', marginBottom: '0.5rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width: (!isMobile)? "91%" :"80%" }} /> */}
                                    <span onClick={togglePasswordVisibility} style={{ cursor: 'pointer', marginLeft: '8px' }}>
                                        {showPassword ? <BsEyeSlash /> : <BsEye />} {/* Eye icon toggle */}
                                    </span>
                    </div>
                    <div onClick={()=>{setShowResetPasswordPage(true); setEmail("");}} style={{cursor: "pointer", fontSize: "13px", marginLeft: "35%", color: "grey", textDecoration: "underline"}}>Reset Password</div>
                    <button onClick={handleLogin} style={{padding: '0.5rem', background: (email && password && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", marginTop: "1rem", width: (!isMobile) ? "22rem":"16rem" }}>Login</button>
                    </>
                        )
                    }
                    {
                        showRestPasswordPage && (
                            <>
                            <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", color: "#343434", marginBottom: "0.3rem"}}>Email</span>
                            <input
                                value={email}
                                type="email"
                                id="email"
                                onChange={(e)=> {setEmail(e.target.value)}}
                                placeholder="name@company.com"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                            {/* <input class="global-input"type="email" onChange={(e)=>setEmail(e.target.value)} placeholder="name@company.com" style={{padding: '0.5rem', marginBottom: '1rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "50%":"80%" }} /> */}
                            {
                                showOTPInput && (
                                    <>
                                    <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", color: "#343434", marginBottom: "0.3rem", marginTop: "0.5rem"}}>OTP</span>
                                    {/* <input class="global-input"type="text" onChange={(e)=>setOTP(e.target.value)} placeholder="OTP" style={{padding: '0.5rem', marginBottom: '1rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "50%":"80%" }} /> */}
                                    <input
                                value={otp}
                                type="text"
                                id="otp"
                                onChange={(e)=> {setOTP(e.target.value)}}
                                placeholder="OTP"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                                    </>
                                )
                            }
                            {
                                showOTPInput ? (
                                    <>
                                    <div style={{fontSize: "13px", color: "grey", marginBottom: "0.5rem"}}>You can resend OTP after {countdown} seconds.</div>
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: (!isMobile) ? "50%":"80%"}}>
                                        <button onClick={handleOTPResend} style={{padding: '0.5rem', background: (resendAllowed && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", width: (!isMobile) ? "10rem":"7rem" }}>Resend</button>
                                        <button onClick={handleOTPVerification} style={{padding: '0.5rem', background: (otp && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", width: (!isMobile) ? "10rem":"7rem" }}>Verify</button>
                                    </div>
                                    </>
                                ) : (
                                    <button onClick={handleVerificationSend} style={{padding: '0.5rem', marginTop: "0.5rem", background: (email && isValidEmail(email) && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", width: (!isMobile) ? "13rem":"16rem" }}>Send Verification OTP</button>
                                )
                            }
                            </>
                        )
                    }
                    {
                        showResetPage && (
                            <>
                            <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", color: "#343434", marginBottom: "0.3rem"}}>New Password</span>
                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
                            <input
                                value={newPassword}
                                type={showNewPassword ? "text" : "password"}
                                id="New password"
                                onChange={(e)=> {setNewPassword(e.target.value)}}
                                placeholder="New Password"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                            {/* <input class="global-input"type={showNewPassword ? "text" : "password"} placeholder="New Password" onChange={(e)=>setNewPassword(e.target.value)} style={{padding: '0.5rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "72%":"80%" }} /> */}
                                            <span onClick={toggleNewPasswordVisibility} style={{ cursor: 'pointer', marginLeft: '8px' }}>
                                                {showNewPassword ? <BsEyeSlash /> : <BsEye />} {/* Eye icon toggle */}
                                            </span>
                            </div>
                            <span style={{width: (!isMobile) ? "52%":"75%", fontSize: "18px", marginTop: "0.5rem", color: "#343434", marginBottom: "0.3rem"}}>Confirm New Password</span>
                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
                            <input value={newConfirmPassword}
                                type={showConfirmNewPassword ? "text" : "password"}
                                id="New password"
                                onChange={(e)=> {setNewConfirmPassword(e.target.value)}}
                                placeholder="Confirm New Password"
                                className={`px-2 py-1.5 h-10 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input`} style={{width: "22rem"}}
                            />
                            {/* <input class="global-input"type={showConfirmNewPassword ? "text" : "password"} placeholder="Confirm New Password" onChange={(e)=>setNewConfirmPassword(e.target.value)} style={{padding: '0.5rem', border: '1px solid #ccc', borderRadius: '5px', outline:"none", width:(!isMobile)?  "72%":"80%" }} /> */}
                                            <span onClick={toggleNewConfirmPasswordVisibility} style={{ cursor: 'pointer', marginLeft: '8px' }}>
                                                {showConfirmNewPassword ? <BsEyeSlash /> : <BsEye />} {/* Eye icon toggle */}
                                            </span>
                            </div>
                            <button onClick={handleResetPassword} style={{padding: '0.5rem', background: (newPassword && newConfirmPassword && !apiCallRunning) ? 'black':'lightgrey', color: 'white', border: 'none', borderRadius: '5px', outline:"none", marginTop: "1rem", width: (!isMobile)? "22rem":"16rem" }}>Reset Password</button>
                            </>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default ManualLogin;
